export const transformEventData = (data) => {
    return data.metadata.map(model => ({
        ...mapper(model),
        name: model.title,
        title: model.title,
        simulation_description: model.description,
        simulation_temporal_extent: model.temporalExtent,
        simulation_temporal_resolution: model.temporalResolution,
        input_files: convertFileStrToJson(model.inputFiles),
        output_files: convertFileStrToJson(model.outputFiles),
        parameters: cleanParametersStrToJson(model.parameters)
    }));
};

export const transformData = (data) => {
    return data.metadata.map(item => mapper(item));
};

const convertFileStrToJson = (fileString) => {
    const formattedJson = fileString.replace(/'/g, '"').replace(/None/g, 'null');
    return JSON.parse(formattedJson).map(item => item.location);
};

const cleanParametersStrToJson = (parameters) => {
    const formattedParams = parameters.replace(/'/g, '"').replace(/None/g, 'null');
    try {
        const parsedParams = JSON.parse(formattedParams);
        return parsedParams.map(item => {
            const value = Array.isArray(item.value) ? item.value[0] : item.value;
            return { [item.parameter]: value };
        });
    } catch(err) {
        // console.log(parameters)
        // console.log(formattedParams)
    }
}

function mapper(item) {
    return {
        name: item.modelName,
        model_name: item.modelName,
        description: item.modelDescription,
        huc_code: item.hucCode,
        model_purpose: item.modelPurpose,
        county_name: item.countyName,
        city_name: item.cityName,
        update_frequency: item.updateFrequency,
        model_type: item.modelType,
        model_software_name: item.modelSoftwareName,
        model_software_version: item.modelSoftwareVersion,
        time_period: item.timePeriod,
        model_last_updated_dt: item.modelLastUpdatedDt,
        tdis_identifier: item.tdisIdentifier,
        location_name: item.locationName,
        additional_info: item.additionalInfo,
        source_application: item.sourceApplication,
        contact_affiliation: item.contactAffiliation,
        contact_name: item.contactName,
        contact_department: item.contactDepartment,
        contact_email: item.contactEmail,
        contact_phone_number: item.contactPhoneNumber
    };
}
